<template>
  <div class="bar-container" :style="{ height: height + 'px' }">
    <svg viewBox="0 0 100 1" preserveAspectRatio="none" class="bar-svg">
      <!-- Fond -->
      <rect
        class="bar-background"
        x="0"
        y="0"
        width="100"
        height="1"
        rx="0.5"
        ry="0.5"
      />
      <!-- Barre de progression -->
      <rect
        class="bar-progress"
        x="0"
        y="0"
        :width="percentage * 100"
        height="1"
        rx="0.5"
        ry="0.5"
        :style="{ fill: color }"
      />
    </svg>
    <div class="bar-label">
      {{ humanizeActivity(value) }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: { type: Number, required: true },
    max: { type: Number, default: 100 },
    height: { type: Number, default: 20 },
    color: { type: String, default: "#4CAF50" },
    label: { type: String, default: "" }
  },
  computed: {
    percentage() {
      return Math.min(this.value / this.max, 1);
    }
  },
  methods: {
    humanizeActivity(time) {
      const hours = Math.floor(time / 60);
      const minutes = time % 60;
      return `${hours} heures ${minutes} minutes`;
    },
  },
};
</script>

<style scoped>
.bar-container {
  width: 100%;
  position: relative;
}

.bar-svg {
  width: 100%;
  height: 100%;
  display: block;
}

.bar-background {
  fill: #ddd;
}

.bar-label {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  font-size: 14px;
  color: #333;
  pointer-events: none; /* pour que la souris passe à travers */
}
</style>
